/* ============================================================
   PRODUCT PAGE — size pills, gallery, quantity, minimum progress.

   Sizes are pills rather than a dropdown because three options do not need
   hiding behind a click. The real <select name="id"> is still in the form and
   still what submits; the pills just drive it, so the page works with
   JavaScript off and Shopify sees a normal product form either way.
   ============================================================ */
(function () {
  'use strict';

  var form = document.getElementById('AddToCartForm');
  if (!form) return;

  var select = document.getElementById('VariantSelect');

  /* ---------- size pills ---------- */

  function selectedValues() {
    var out = [];
    document.querySelectorAll('[data-option-position]').forEach(function (btn) {
      if (btn.getAttribute('aria-pressed') === 'true') {
        out[parseInt(btn.dataset.optionPosition, 10) - 1] = btn.dataset.optionValue;
      }
    });
    return out;
  }

  function syncVariant() {
    if (!select) return;
    var wanted = selectedValues().join(' / ');
    var match = null;
    [].forEach.call(select.options, function (opt) {
      if (opt.dataset.title === wanted) match = opt;
    });
    if (!match) return;

    select.value = match.value;

    var price = document.getElementById('price');
    var unit  = document.getElementById('unit');
    if (price) price.textContent = match.dataset.priceFormatted;
    if (unit)  unit.textContent  = match.dataset.title === 'Default Title' ? '' : match.dataset.title;

    var add = form.querySelector('[name="add"]');
    if (add) add.disabled = match.disabled;

    /* Keep the address bar honest, the way Shopify's own themes do. */
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url.toString());
    }

    if (window.ALGGalleryShow) window.ALGGalleryShow(match.getAttribute("data-image-id"));

    updateNotes();
    updateMinimum();
  }

  /* ---------- size-dependent blocks ----------
     Anything with data-sizes (the lead-time note, the heating steps for the
     large trays) shows only while one of those sizes is picked, and anything
     with data-sizes-except shows only while none of them is. Sizes are compared
     the same loose way the Liquid does, so "1.2kg" in the editor matches a
     "1.2kgs" option. */

  function sizeKey(value) {
    return String(value || '').toLowerCase().replace(/ /g, '').replace(/kgs/g, 'kg').replace(/gms/g, 'g');
  }

  function sizeListMatches(list, picked) {
    var sizes = list.split('|');
    return picked.some(function (value) { return sizes.indexOf(value) !== -1; });
  }

  function updateNotes() {
    var picked = selectedValues().map(sizeKey);
    document.querySelectorAll('[data-sizes]').forEach(function (el) {
      el.hidden = !sizeListMatches(el.dataset.sizes, picked);
    });
    /* data-sizes-except is the other half of the same list: the heating steps
       for the smaller trays, hidden once a large one is picked. */
    document.querySelectorAll('[data-sizes-except]').forEach(function (el) {
      el.hidden = sizeListMatches(el.dataset.sizesExcept, picked);
    });
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-option-position]');
    if (!pill) return;
    var position = pill.dataset.optionPosition;

    document.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === pill ? 'true' : 'false');
    });

    var label = document.querySelector('[data-option-label="' + position + '"]');
    if (label) label.textContent = pill.dataset.optionValue;

    syncVariant();
  });

  /* ---------- quantity ---------- */

  var qty = document.getElementById('qty');
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-step]');
    if (!step || !qty || !step.closest('.qty')) return;
    var next = (parseInt(qty.value, 10) || 1) + parseInt(step.dataset.step, 10);
    qty.value = next < 1 ? 1 : next;
    updateMinimum();
  });
  if (qty) qty.addEventListener('change', updateMinimum);

  /* ---------- gallery ---------- */

  var track = document.getElementById('galTrack');
  if (track) {
    var slides = [].slice.call(track.querySelectorAll('.gal__slide'));
    var thumbs = [].slice.call(document.querySelectorAll('.gal__thumb'));
    var indexOut = document.getElementById('galIndex');

    var current = function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      return Math.max(0, Math.min(slides.length - 1, i));
    };

    var mark = function (i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (indexOut) indexOut.textContent = i + 1;
    };

    var go = function (i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    };

    track.addEventListener('scroll', function () { mark(current()); }, { passive: true });

    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('.gal__thumb');
      if (thumb) { go(parseInt(thumb.dataset.galIndex, 10) || 0); return; }
      var nav = e.target.closest('[data-gal-step]');
      if (nav) go(current() + (parseInt(nav.dataset.galStep, 10) || 0));
    });

    /* A size with its own photo (the 1.2kg tray, say) brings that photo forward. */
    window.ALGGalleryShow = function (imageId) {
      if (!imageId) return;
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].getAttribute('data-image-id') === String(imageId)) { go(n); return; }
      }
    };
  }

  /* ---------- minimum order progress ----------
     Shows what this product does towards the minimum, counting what is
     already in the basket. Recalculates when the cart changes. */

  function updateMinimum() {
    var wrap = document.getElementById('minim');
    if (!wrap || !window.ALGCart) return;

    var MIN = window.ALGCart.minimum;
    if (!MIN) { wrap.style.display = 'none'; return; }

    var opt   = select ? select.options[select.selectedIndex] : null;
    var price = opt ? parseInt(opt.dataset.price, 10) : 0;
    var count = qty ? (parseInt(qty.value, 10) || 1) : 1;
    var inCart = window.ALGCart.state().total_price || 0;
    var projected = inCart + (price * count);
    var left = MIN - projected;

    var text = document.getElementById('minimT');
    var fill = document.getElementById('minimFill');
    if (fill) fill.style.width = Math.min(100, projected / MIN * 100) + '%';
    if (text) {
      text.innerHTML = left <= 0
        ? 'This order clears the ' + window.ALGCart.money(MIN) + ' minimum.'
        : '<b>' + window.ALGCart.money(left) + '</b> to go towards the ' + window.ALGCart.money(MIN) + ' minimum';
    }
    wrap.classList.toggle('met', left <= 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.ALGCart) window.ALGCart.onChange(updateMinimum);
    updateMinimum();
  });
})();

/* ============================================================
   ACCORDION — ingredients, nutrition, heating, storage.

   The markup and the styling for these panels shipped without anything to
   open them: .acc__panel is max-height:0 in the stylesheet and nothing ever
   set it back, so every panel was shut on every product and clicking a
   heading did nothing. Height is measured rather than guessed, so a long
   ingredient statement or a nutrition table is never cut off.
   ============================================================ */
(function () {
  'use strict';

  function height(item) {
    var panel = item.querySelector('.acc__panel');
    if (!panel) return;
    panel.style.maxHeight = item.classList.contains('open') ? panel.scrollHeight + 'px' : '0px';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.acc__btn');
    if (!btn) return;
    var item = btn.closest('.acc__item');
    if (!item) return;
    var open = !item.classList.contains('open');
    item.classList.toggle('open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    height(item);
  });

  function start() {
    document.querySelectorAll('.acc__item').forEach(function (item) {
      var btn = item.querySelector('.acc__btn');
      if (btn) btn.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
      height(item);
    });
  }

  /* An open panel is remeasured when the page reflows, or it clips. */
  window.addEventListener('resize', start);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
